import { put, takeLatest } from 'redux-saga/effects';
import { getUserRecentSearch, updateRecentSearch } from "@/api/home";
import { fetchRecentSearchFailure, fetchRecentSearchSuccess, updateRecentSearchFailure, updateRecentSearchSuccess } from "./recentSearchSlice";

export function* fetchRecentSearchesSaga(action) {
  const response = yield getUserRecentSearch(action.payload);
  if (response) {
    yield put(fetchRecentSearchSuccess(response));
  } else {
    yield put(fetchRecentSearchFailure(response));
  }
}

export function* updateRecentSearchSaga(action) {
  const {searchBy, type, iD} = action.payload;
  const response = yield updateRecentSearch(searchBy, type, iD);
  if (response) {
    yield put(updateRecentSearchSuccess(response));
  } else {
    yield put(updateRecentSearchFailure(response?.data?.errorMessage));
  }
}
export function* watchRecentSearchesSaga() {
  yield takeLatest('recentSearch/fetchRecentSearch', fetchRecentSearchesSaga);
  yield takeLatest('recentSearch/updateRecentSearch', updateRecentSearchSaga);
}